import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CarouselMulti from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Banner1 from ".././../asset/images/newsroombanner/news_banner1.webp"
import Banner2 from ".././../asset/images/newsroombanner/news_banner2.webp"
import Banner3 from ".././../asset/images/newsroombanner/news_banner3.webp"

import logo3 from ".././../asset/images/newsroombanner/newsroom-logos/logo3.webp";
import logo4 from ".././../asset/images/newsroombanner/newsroom-logos/bis_logo.webp";
// import logo4 from ".././../asset/images/newsroombanner/newsroom-logos/express-computer.webp";
// import logo5 from ".././../asset/images/newsroombanner/newsroom-logos/business-news-this-week.webp";
// import logo6 from ".././../asset/images/newsroombanner/newsroom-logos/cxo-today.webp";
// import logo7 from ".././../asset/images/newsroombanner/newsroom-logos/marcamoney.webp";

import logo8 from ".././../asset/images/newsroombanner/newsroom-logos/technuter.webp";
import logo9 from ".././../asset/images/newsroombanner/newsroom-logos/varindia.webp";
import logo10 from ".././../asset/images/newsroombanner/newsroom-logos/yourstory.webp";
import logo11 from ".././../asset/images/newsroombanner/newsroom-logos/cxomedia.webp";
import logo12 from ".././../asset/images/newsroombanner/newsroom-logos/apn-news.webp";



export default function NewsRoomBanner() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };


  return (
    <>


      <Helmet>
        <meta charset="UTF-8" />
        <h1>Decimal Point Analytics | Data Analytics | AI Consulting | Market Research</h1>
        <title>Decimal Point Analytics | Data Analytics | AI Consulting | Market Research </title>
        <meta name="description" content="Transform your business with Decimal Point Analytics. Our data analytics, AI consulting, and market research provide actionable insights for superior, data-driven decisions" />
        <meta name="keywords" content="data analytics, AI consulting, market research, data-driven decisions, customized solutions, actionable insights, Decimal Point Analytics" />
        <meta name="author" content="Decimal Point Analytics" />
        <link rel="canonical" href="https://www.decimalpointanalytics.com/" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org/",
              "@type": "WebSite",
              "name": "Decimal Point Analytics",
              "url": "https://www.decimalpointanalytics.com/",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://www.decimalpointanalytics.com/search?q={search_term_string}https://www.decimalpointanalytics.com/insight",
                "query-input": "required name=search_term_string"
              }
            }
          `}
        </script>
      </Helmet>

      <Box id="new_landing_carousel" className="press-banner">
        <CarouselMulti
          responsive={responsive}
          arrows={false}
          swipeable={true}
          draggable={true}
          showDots={true}
          infinite={true}
          autoPlay={true}
          pauseOnHover={false}
          keyBoardControl={true}
          // transitionDuration={1500}
          customTransition="opacity 200ms ease-in-out"
          autoPlaySpeed={9500}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-0-px"
        >
           <>
            <Box className="mainsection1" component="section" style={{ backgroundImage: "url(" + Banner1 + ")" }} pb={2}>
              <Container maxWidth="lg">
                <Grid container spacing={1} alignItems="center" justifyContent='center'>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box className="text_animated new-design press-banner">

                      <Box>
                        <Typography variant="h6" className="black small-heading" gutterBottom>
                          FEATURED IN THE MAY EDITION OF
                        </Typography>
                      </Box>

                      <Box className="bis-logo" my={4}>
                        <img loading="lazy" src={logo4} alt="newsroom logo" />
                      </Box>

                      <Box className="fx_c">
                        <Box className="bltopBorder" my={'30px'} />
                      </Box>

                      <Typography variant="h1" className="blue fw7 mb0" gutterBottom>
                       Leveraging AI <span className="lower">for</span> Data-Driven Insights
                      </Typography>

                      <Typography variant="h1" className="blue fw4 mb0" gutterBottom>
                        The Role <span className="lower">of</span> Decimal Point Analytics
                      </Typography>

                      {/* <Box className="bottomBorder" mt={'40px'} /> */}
                      <Box mt={4}>
                        <Link to="/leveraging-ai-for-data-driven-insights-the-role-of-decimal-point-analytics">
                          <Button variant="contained" className='dpabtn_sm2'>
                            Read More
                          </Button>
                        </Link>
                      </Box>
                    </Box>

                  </Grid>
                </Grid>
              </Container>
            </Box>
          </>
          <>
            <Box className="mainsection1" component="section" style={{ backgroundImage: "url(" + Banner3 + ")" }} pb={2}>
              <Container maxWidth="lg">
                <Grid container spacing={1} alignItems="center" justifyContent='center'>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box className="text_animated new-design press-banner">

                      <Box>
                        <Typography variant="h6" className="black small-heading" gutterBottom>
                          FEATURED IN
                        </Typography>
                      </Box>

                      <Box className="cio-logo" my={4}>
                        <img loading="lazy" src={logo3} alt="newsroom logo" />
                      </Box>

                      <Box className="fx_c">
                        <Box className="bltopBorder" my={'30px'} />
                      </Box>

                      <Typography variant="h1" className="blue fw7 mb0" gutterBottom>
                        Harnessing Technology
                      </Typography>

                      <Typography variant="h1" className="blue fw4 mb0" gutterBottom>
                        to Improve Hedge Accounting Integrity
                      </Typography>

                      {/* <Box className="bottomBorder" mt={'40px'} /> */}
                      <Box mt={4}>
                        <Link to="/harnessing-technology-to-improve-hedge-accounting-integrity">
                          <Button variant="contained" className='dpabtn_sm2'>
                            Read More
                          </Button>
                        </Link>
                      </Box>
                    </Box>

                  </Grid>
                </Grid>
              </Container>
            </Box>
          </>
          <>
            <Box className="mainsection1" component="section" style={{ backgroundImage: "url(" + Banner2 + ")" }} pb={2}>
              <Container maxWidth="lg">
                <Grid container spacing={1} alignItems="center" justifyContent='center'>
                  <Grid item lg={9} md={9} sm={12} xs={12}>
                    <Box className="text_animated new-design press-banner">

                      <Box>
                        <Typography variant="h6" className="black small-heading" gutterBottom>
                          FEATURED IN
                        </Typography>
                      </Box>

                      <Box my={4}>
                        <Grid container spacing={2} justifyContent="center">
                          <Grid item xs="auto" md="auto">
                            <Box className="bannerwhitebx">
                              <a href="https://technuter.com/top-breaking-news-of-the-day" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src={logo8} alt="newsroom logo" />
                              </a>
                            </Box>
                          </Grid>
                          <Grid item xs="auto" md="auto">
                            <Box className="bannerwhitebx">
                              <a href="https://varindia.com/news/eric-yuen-joins-decimal-point-analytics-as-head-of-data-science" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src={logo9} alt="newsroom logo" />
                              </a>
                            </Box>
                          </Grid>
                          <Grid item xs="auto" md="auto">
                            <Box className="bannerwhitebx">
                              <a href="https://yourstory.com/2025/04/startup-news-updates-daily-roundup-april-8-2025" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src={logo10} alt="newsroom logo" />
                              </a>
                            </Box>
                          </Grid>
                          <Grid item xs="auto" md="auto">
                            <Box className="bannerwhitebx">
                              <a href="https://cxomedia.in/hr-movements/decimal-point-analytics-names-eric-yuen-as-partner-and-head-of-data-science/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src={logo11} alt="newsroom logo" />
                              </a>
                            </Box>
                          </Grid>
                          <Grid item xs="auto" md="auto">
                            <Box className="bannerwhitebx">
                              <a href="https://www.apnnews.com/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src={logo12} alt="newsroom logo" />
                              </a>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>

                      <Typography variant="h1" className="blue fw4 mb0" gutterBottom>
                        Decimal Point Analytics Appoints
                      </Typography>

                      <Box>
                        <Typography variant="h1" className="blue fw7 mb0" gutterBottom>
                          Eric Yuen <span className="lower">as</span> Partner <span className="lower">and</span> Head <span className="lower">of</span> Data Science
                        </Typography>
                      </Box>

                      {/* <Box className="bottomBorder" mt={'40px'} /> */}
                      <Box mt={4}>
                        <Link to="/decimal-point-analytics-appoints-eric-yuen-as-partner-and-head-of-data-science">
                          <Button variant="contained" className='dpabtn_sm2'>
                            Read More
                          </Button>
                        </Link>
                      </Box>
                    </Box>

                  </Grid>

                </Grid>
              </Container>
            </Box>
          </>
          {/* <>
            <Box className="mainsection1" component="section" style={{ backgroundImage: "url(" + Banner1 + ")" }} pb={2}>
              <Container maxWidth="lg">
                <Grid container spacing={1} alignItems="center" justifyContent='center'>
                  <Grid item lg={7} md={12} sm={12} xs={12}>
                    <Box className="text_animated new-design press-banner">

                      <Box>
                        <Typography variant="h6" className="black small-heading" gutterBottom>
                          FEATURED IN
                        </Typography>
                      </Box>

                      <Box my={4}>
                        <Grid container spacing={2} justifyContent="center">
                          <Grid item xs={6} md="auto">
                            <Box className="bannerwhitebx">
                              <a href="https://www.expresscomputer.in/news/decimal-point-analytics-strengthens-leadership-team-to-drive-innovation-and-client-centric-growth/123733/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src={logo4} alt="newsroom logo" />
                              </a>
                            </Box>
                          </Grid>
                          <Grid item xs={6} md="auto">
                            <Box className="bannerwhitebx">
                              <a href="https://businessnewsthisweek.com/business/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src={logo5} alt="newsroom logo" />
                              </a>
                            </Box>
                          </Grid>
                          <Grid item xs={6} md="auto">
                            <Box className="bannerwhitebx">
                              <a href="https://cxotoday.com/press-release/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src={logo6} alt="newsroom logo" />
                              </a>
                            </Box>
                          </Grid>
                          <Grid item xs={6} md="auto">
                            <Box className="bannerwhitebx">
                              <a href="https://www.marcamoney.com/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src={logo7} alt="newsroom logo" />
                              </a>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>

                      <Typography variant="h1" className="blue fw4 mb0" gutterBottom>
                        Decimal Point Analytics Elevates
                      </Typography>

                      <Box>
                        <Typography variant="h1" className="blue fw4 mb0" gutterBottom>
                          <span className="fw7 ">Vaibhav Poonekar <span className="lower">to</span> CTO <span className="lower">in</span> Key Internal Leadership Promotions</span>
                        </Typography>
                      </Box> 

                      <Box mt={4}>
                        <Link to="/decimal-point-analytics-elevates-vaibhav-poonekar-to-cto-in-key-internal-leadership-promotions">
                          <Button variant="contained" className='dpabtn_sm2'>
                            Read More
                          </Button>
                        </Link>
                      </Box>
                    </Box>

                  </Grid>

                </Grid>
              </Container>
            </Box>
          </>  */}
        </CarouselMulti>
      </Box>
    </>
  );
}